export const getMarkets = (store: Store) => store.markets.markets;
export const getIsLoadingMarkets = (store: Store) => store.markets.isLoading;
